import { keymap } from '@codemirror/view';
import {
  toggleBold,
  toggleItalic,
  toggleInlineCode,
  insertLink,
} from './commands.ts';

/**
 * Keyboard shortcuts. Layered above the default markdown + history
 * keymaps in the editor; see editor.tsx for the order.
 */
export const houseopsKeymap = keymap.of([
  { key: 'Mod-b', preventDefault: true, run: toggleBold },
  { key: 'Mod-i', preventDefault: true, run: toggleItalic },
  { key: 'Mod-e', preventDefault: true, run: toggleInlineCode },
  { key: 'Mod-k', preventDefault: true, run: (v) => insertLink(v) },
]);
